{
  "gate": {
    "whatToDo": "What to do",
    "checking": "Checking…",
    "checkAgain": "Check again",
    "checkAgainA11y": "Check location again",
    "privacyTitle": "Your location stays private",
    "privacyBody": "Opncue uses your location to identify your current venue. Your precise location is not displayed to other users.",
    "requiredFooter": "Location access is required to use Opncue.",
    "states": {
      "checkingEyebrow": "CHECKING LOCATION",
      "checkingTitle": "Finding your space",
      "checkingBody": "We’re checking whether Opncue can access your location.",
      "requiredEyebrow": "LOCATION REQUIRED",
      "requiredTitle": "Allow location access",
      "requiredWebBody": "Select Allow location and {{browser}} will ask whether Opncue can use your current location.",
      "requiredNativeBody": "Opncue connects you with people in the same physical space. Allow location while using the app to continue.",
      "allowLocation": "Allow location",
      "blockedEyebrow": "LOCATION BLOCKED",
      "blockedWebTitle": "Location is blocked in {{browser}}",
      "blockedWebBody": "Your browser is preventing Opncue from requesting your location. Change the permission for this site, then check again.",
      "blockedNativeTitle": "Allow location in Settings",
      "blockedNativeBody": "Location permission is currently blocked. Open your device settings and allow Opncue to use your location.",
      "openSettings": "Open settings",
      "unavailableEyebrow": "LOCATION UNAVAILABLE",
      "unavailableTitle": "Your location could not be found",
      "unavailableMacBody": "{{browser}} has permission, but macOS could not provide a location. Check Location Services for your browser.",
      "unavailableDeviceBody": "{{browser}} has permission, but your device could not provide a location.",
      "offEyebrow": "LOCATION IS OFF",
      "offTitle": "Turn on device location",
      "offBody": "Opncue has permission to use your location, but location is turned off on this device. Turn it on to find people nearby.",
      "turnOnLocation": "Open location settings",
      "secureEyebrow": "SECURE CONNECTION REQUIRED",
      "secureTitle": "Location needs a secure connection",
      "secureBody": "Your browser only allows location access on secure websites.",
      "unsupportedEyebrow": "LOCATION UNSUPPORTED",
      "unsupportedTitle": "This browser cannot share location",
      "unsupportedBody": "Opncue could not find browser support for location access.",
      "errorEyebrow": "LOCATION ERROR",
      "errorTitle": "We couldn’t check your location",
      "errorBody": "The location request did not complete. Check your connection and location settings, then try again.",
      "readyEyebrow": "LOCATION READY",
      "readyTitle": "Location is available",
      "readyBody": "Opncue can now find your current venue."
    },
    "instructions": {
      "macOpenSettings": "Open Mac System Settings.",
      "macOpenLocation": "Go to Privacy & Security, then Location Services.",
      "enableBrowser": "Turn on Location Services and make sure {{browser}} is allowed.",
      "returnCheck": "Return to Opncue and select Check again.",
      "enableDevice": "Make sure location services are enabled on your device.",
      "allowBrowser": "Make sure {{browser}} is allowed to use location.",
      "openHttps": "Open Opncue using an HTTPS address.",
      "useLocalhost": "During local development, use localhost rather than a local network IP address when possible.",
      "reloadCheck": "Reload the page, then select Check again.",
      "currentBrowser": "Open Opncue in a current version of Chrome, Safari, Firefox, or Microsoft Edge.",
      "extensions": "Make sure browser location features are not disabled by an extension or organization policy.",
      "reloadRetry": "Reload Opncue and try again.",
      "chromeControls": "Click the controls icon beside the address bar.",
      "allowSite": "Set Location to Allow for this site.",
      "edgeSiteInfo": "Click the site information icon beside the address bar.",
      "edgePermissions": "Open Permissions for this site and set Location to Allow.",
      "safariSettings": "Open Safari Settings and select Websites.",
      "safariLocation": "Select Location and set this website to Allow.",
      "firefoxPermissions": "Click the location or permissions icon beside the address bar.",
      "firefoxAllow": "Remove the blocked location permission or select Allow.",
      "genericPermissions": "Open the permissions for this website from the browser address bar.",
      "genericAllow": "Change Location to Allow."
    }
  },
  "editor": {
    "radiusMeters": "{{count}} metres",
    "radiusKilometres": "{{count}} km",
    "metersAway": "{{distance}} m away",
    "milesAway": "{{distance}} mi away",
    "title": "Join a space",
    "body": "Choose a venue within {{radius}} of your live location. You’ll see the people who joined it, and they’ll see you.",
    "closeA11y": "Close location search",
    "placeholder": "Type a café, bar, library, venue…",
    "clearA11y": "Clear location search",
    "gpsUnavailable": "GPS is unavailable",
    "gpsRequired": "Your live position is needed to enforce the {{radius}} limit.",
    "retryGpsA11y": "Try getting GPS location again",
    "matchingPlaces": "Matching places",
    "closestPlaces": "Closest places",
    "suggestionCount_one": "{{count}} suggestion",
    "suggestionCount_other": "{{count}} suggestions",
    "currentLocationA11y": "{{name}} is your current location",
    "setLocationA11y": "Set location to {{name}}",
    "current": "Current",
    "nearbyVenue": "Nearby venue",
    "findingMatches": "Finding nearby matches…",
    "noMatchTitle": "No nearby match",
    "minChars": "Type at least {{count}} characters to search nearby venues.",
    "tryName": "Try the first letters of the venue name. Results beyond {{radius}} stay hidden.",
    "noneInRadius": "No eligible venues were found within {{radius}} of your GPS position.",
    "tooFarTitle": "Too far from this space",
    "tooFarBody": "You need to be within {{radius}} of {{name}} to join it. Move closer and try again.",
    "tooFarA11y": "{{name}} is too far to join. You need to be within {{radius}}.",
    "updateFailedTitle": "Could not update",
    "updateFailedBody": "Something went wrong setting that location. Try again.",
    "geolocationUnavailable": "Geolocation is unavailable.",
    "areaContextA11y": "{{name}} — nearby area, not a space you can join"
  }
}
